module.exports = __webpack_public_path__ + "static/media/chevron-right-green.96b27411.svg";